import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { of } from "rxjs/observable/of";
import { timeout, catchError } from "rxjs/operators";
import { v4 as uuid4 } from "uuid";

import { environment } from "@env/environment";
import { Email } from "@common/models";
import { LoggingService } from "@app/services/logging.service";


const API_SERVER = environment.apiServer;
const MODULE_PATH = [
  "@auctions",
  "components",
  "home-main-modal-detail",
  "auction-type-change-email-dialog",
].join(".");


@Component({
  selector: "app-auction-type-change-email-dialog",
  templateUrl: "./auction-type-change-email-dialog.component.html",
  styleUrls: ["./auction-type-change-email-dialog.component.sass"],
})
export class AuctionTypeChangeEmailDialogComponent implements OnInit {

  @Input() auctionNumber!: string;
  @Output() closeDialog = new EventEmitter<"send" | "cancel">();

  isLoading: boolean;

  emailForm = new FormGroup({
    recipients: new FormControl("", []),
    copyRecipients: new FormControl("", []),
    subject: new FormControl("", []),
    body: new FormControl("", [
      Validators.required,
    ]),
  });

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _spinnerService: NgxSpinnerService,
    private readonly _loggingService: LoggingService,
  ) {
    this.isLoading = true;
  }

  // TODO: Добавить синхронный декоратор для логирования.
  async ngOnInit(): Promise<void> {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.AuctionTypeChangeEmailDialogComponent.ngOnInit`;
    const inputParams = {};
    const description = "Инициализация модальной формы отправки письма об изменении типа аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);
      this._spinnerService.show();

      // TODO: Перенести в API-сервис.
      const email = await this._httpClient.get<Email>(
        `${API_SERVER}/mailing/email-templates/auction-type-change`, {
          params: {
            auctionNumber: this.auctionNumber,
          },
        })
        .pipe(
          timeout(3000),
          catchError(() => {
            return of<Email>({
              recipients: "",
              copyRecipients: "",
              subject: "",
              body: "",
            });
          }),
        )
        .toPromise();

      this.emailForm.patchValue(email);

      this.isLoading = false;

      this._spinnerService.hide();
      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._spinnerService.hide();
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  // TODO: Добавить синхронный декоратор для логирования.
  async onSendButtonClick(): Promise<void> {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.AuctionTypeChangeEmailDialogComponent.onSendButtonClick`;
    const inputParams = {};
    const description = "[EventHandler] Обработка нажатия на кнопку отправки письма";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);
      this._spinnerService.show();

      const email: Email = {
        recipients: "",
        copyRecipients: "",
        subject: "",
        body: "",
        ...this.emailForm.value,
      };

      // TODO: Перенести в API-сервис.
      await this._httpClient.post<void>(
        `${API_SERVER}/mailing/emails/auction-type-change`,
        email, {
          params: {
            auctionNumber: this.auctionNumber,
          },
        })
        .pipe(
          timeout(3000),
        )
        .toPromise();

      this.closeDialog.emit("send");

      this._spinnerService.hide();
      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._spinnerService.hide();
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  // TODO: Добавить синхронный декоратор для логирования.
  onCancelButtonClick(): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.AuctionTypeChangeEmailDialogComponent.onCancelButtonClick`;
    const inputParams = {};
    const description = "[EventHandler] Обработка нажатия на кнопку отмены отправки письма";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this.closeDialog.emit("cancel");

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/auction-type-change-email-dialog/auction-type-change-email-dialog.component.ts